// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* BASIC */
.Login {
  background-color: white;
  position: relative;
  z-index: 1;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  max-width: 450px;
  position: relative;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
}

#formFooter {
  background: transparent;
  border-top: none;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 0px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

.Login {
  display: flex;
  align-items: center;
  justify-content: center;
}

.formContent {
  font-family: "Raleway" !important;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  max-width: 450px;
  position: relative;
  text-align: center;
  min-width: 450px;
  overflow: hidden;
  padding: 20px 0px 0px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5) !important;
  border: 1px solid lightgrey;
}
.formContent .top-head {
  font-weight: 500 !important;
  font-size: 22px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  line-height: 26px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 23px 0 33px;
  margin: 0;
}
.formContent .top-head .auth-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: 50%;
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.formContent .top-head .auth-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.formContent .top-head .auth-modal-close mat-icon {
  color: #606060;
  font-size: 20px;
  width: 20px;
  height: 20px;
  transition: color 0.2s ease;
}
.formContent .top-head .auth-modal-close:hover mat-icon {
  color: #333;
}
.formContent .form-group {
  width: 85%;
  max-width: 85%;
  margin: 0 auto 20px;
  overflow: visible;
}
.formContent .form-group input {
  width: 100%;
  background-color: #fff;
  margin: 0;
  padding: 8px 32px;
  border: 1px solid lightgray;
  font-size: 16px;
}
.formContent .form-group mat-form-field {
  overflow: visible !important;
}
.formContent #formFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 25px 25px 0px 25px;
  background: transparent;
  border-top: none;
  max-width: 100%;
  width: 100%;
  /* Sign In — outline button */
  /* Sign Up — filled primary */
}
.formContent #formFooter button,
.formContent #formFooter button.btn {
  font-family: "Raleway", sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 18px;
  border-radius: 10px;
  min-width: 110px;
  line-height: 1.3;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  box-shadow: none !important;
}
.formContent #formFooter .btn-auth-secondary,
.formContent #formFooter button:first-child {
  background: transparent !important;
  background-image: none !important;
  color: #5ea1d8 !important;
  border: 1.5px solid #5ea1d8 !important;
}
.formContent #formFooter .btn-auth-secondary:hover, .formContent #formFooter .btn-auth-secondary:focus,
.formContent #formFooter button:first-child:hover,
.formContent #formFooter button:first-child:focus {
  background: rgba(94, 161, 216, 0.1) !important;
  color: #4a8fc4 !important;
  border-color: #4a8fc4 !important;
}
.formContent #formFooter .btn-auth-primary,
.formContent #formFooter button[type=submit],
.formContent #formFooter button:last-child {
  background: #5ea1d8 !important;
  background-image: none !important;
  color: #ffffff !important;
  border: 1.5px solid #5ea1d8 !important;
}
.formContent #formFooter .btn-auth-primary:hover, .formContent #formFooter .btn-auth-primary:focus,
.formContent #formFooter button[type=submit]:hover,
.formContent #formFooter button[type=submit]:focus,
.formContent #formFooter button:last-child:hover,
.formContent #formFooter button:last-child:focus {
  background: #4a8fc4 !important;
  border-color: #4a8fc4 !important;
  color: #ffffff !important;
}
.formContent #formFooter .btn-auth-primary:disabled,
.formContent #formFooter button[type=submit]:disabled,
.formContent #formFooter button:last-child:disabled {
  background: #94a3b8 !important;
  border-color: #94a3b8 !important;
  color: #ffffff !important;
  opacity: 0.7;
  cursor: not-allowed;
}
.formContent::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.formContent::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.formContent::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .formContent {
    max-width: 100%;
    padding: 0 20px;
  }
}
@media (max-width: 460px) {
  .formContent {
    min-width: auto;
  }
  .formContent .form-group {
    max-width: 100%;
    width: 100%;
  }
  .formContent .form-group input {
    width: 100%;
  }
  .formContent #formFooter {
    padding: 25px 0px 0px;
  }
  .formContent .top-head {
    padding: 20px 6px 0 5px;
  }
}
.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .formContent,
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
  color: #e5e7eb !important;
  /* I agree checkbox — Material MDC label stays dark unless overridden */
  /* User Type mat-select / form field */
}
:host-context(body.theme-dark) .formContent .top-head,
:host-context(body.theme-dark) #formContent .top-head {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .formContent input,
:host-context(body.theme-dark) #formContent input {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .formContent input::-webkit-input-placeholder,
:host-context(body.theme-dark) #formContent input::-webkit-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) .formContent input::-moz-placeholder,
:host-context(body.theme-dark) #formContent input::-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) .formContent input:-ms-input-placeholder,
:host-context(body.theme-dark) #formContent input:-ms-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) .formContent input:-moz-placeholder,
:host-context(body.theme-dark) #formContent input:-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) .formContent .form-group input,
:host-context(body.theme-dark) #formContent .form-group input {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .formContent .example-margin,
:host-context(body.theme-dark) .formContent .example-section,
:host-context(body.theme-dark) .formContent .checkbox-section,
:host-context(body.theme-dark) .formContent p,
:host-context(body.theme-dark) #formContent .example-margin,
:host-context(body.theme-dark) #formContent .example-section,
:host-context(body.theme-dark) #formContent .checkbox-section,
:host-context(body.theme-dark) #formContent p {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-checkbox .mdc-label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-checkbox label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-checkbox .mat-checkbox-label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-checkbox .mdc-label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-checkbox label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-checkbox .mat-checkbox-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-checkbox .mdc-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-checkbox label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-checkbox .mat-checkbox-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-checkbox .mdc-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-checkbox label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-checkbox .mat-checkbox-label {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-checkbox a,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-checkbox a,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-checkbox a,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-checkbox a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-checkbox .mdc-checkbox__background,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-checkbox .mdc-checkbox__background,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-checkbox .mdc-checkbox__background,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-checkbox .mdc-checkbox__background {
  border-color: #94a3b8 !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background {
  background-color: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled),
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: #111827 !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mdc-floating-label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mat-mdc-floating-label,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field mat-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mdc-floating-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mat-mdc-floating-label,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field mat-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-value,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-min-line,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-placeholder,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-value,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-min-line,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-placeholder {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-arrow,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mat-mdc-select-arrow {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mdc-line-ripple::before,
:host-context(body.theme-dark) .formContent ::ng-deep .mat-mdc-form-field .mdc-line-ripple::after,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mdc-line-ripple::before,
:host-context(body.theme-dark) #formContent ::ng-deep .mat-mdc-form-field .mdc-line-ripple::after {
  border-bottom-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .formContent .auth-modal-close mat-icon,
:host-context(body.theme-dark) #formContent .auth-modal-close mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .formContent .auth-modal-close:hover,
:host-context(body.theme-dark) #formContent .auth-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
:host-context(body.theme-dark) .formContent .auth-modal-close:hover mat-icon,
:host-context(body.theme-dark) #formContent .auth-modal-close:hover mat-icon {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .formContent #formFooter,
:host-context(body.theme-dark) #formContent #formFooter {
  background: transparent !important;
  border-top: none !important;
}
:host-context(body.theme-dark) .formContent #formFooter .btn-auth-secondary,
:host-context(body.theme-dark) .formContent #formFooter button:first-child,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-secondary,
:host-context(body.theme-dark) #formContent #formFooter button:first-child {
  background: transparent !important;
  color: #7eb8e8 !important;
  border: 1.5px solid #7eb8e8 !important;
}
:host-context(body.theme-dark) .formContent #formFooter .btn-auth-secondary:hover, :host-context(body.theme-dark) .formContent #formFooter .btn-auth-secondary:focus,
:host-context(body.theme-dark) .formContent #formFooter button:first-child:hover,
:host-context(body.theme-dark) .formContent #formFooter button:first-child:focus,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-secondary:hover,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-secondary:focus,
:host-context(body.theme-dark) #formContent #formFooter button:first-child:hover,
:host-context(body.theme-dark) #formContent #formFooter button:first-child:focus {
  background: rgba(126, 184, 232, 0.12) !important;
  color: #93c5fd !important;
  border-color: #93c5fd !important;
}
:host-context(body.theme-dark) .formContent #formFooter .btn-auth-primary,
:host-context(body.theme-dark) .formContent #formFooter button[type=submit],
:host-context(body.theme-dark) .formContent #formFooter button:last-child,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-primary,
:host-context(body.theme-dark) #formContent #formFooter button[type=submit],
:host-context(body.theme-dark) #formContent #formFooter button:last-child {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border: 1.5px solid #5ea1d8 !important;
}
:host-context(body.theme-dark) .formContent #formFooter .btn-auth-primary:hover, :host-context(body.theme-dark) .formContent #formFooter .btn-auth-primary:focus,
:host-context(body.theme-dark) .formContent #formFooter button[type=submit]:hover,
:host-context(body.theme-dark) .formContent #formFooter button[type=submit]:focus,
:host-context(body.theme-dark) .formContent #formFooter button:last-child:hover,
:host-context(body.theme-dark) .formContent #formFooter button:last-child:focus,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-primary:hover,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-primary:focus,
:host-context(body.theme-dark) #formContent #formFooter button[type=submit]:hover,
:host-context(body.theme-dark) #formContent #formFooter button[type=submit]:focus,
:host-context(body.theme-dark) #formContent #formFooter button:last-child:hover,
:host-context(body.theme-dark) #formContent #formFooter button:last-child:focus {
  background: #4a8fc4 !important;
  border-color: #4a8fc4 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .formContent #formFooter .btn-auth-primary:disabled,
:host-context(body.theme-dark) .formContent #formFooter button[type=submit]:disabled,
:host-context(body.theme-dark) .formContent #formFooter button:last-child:disabled,
:host-context(body.theme-dark) #formContent #formFooter .btn-auth-primary:disabled,
:host-context(body.theme-dark) #formContent #formFooter button[type=submit]:disabled,
:host-context(body.theme-dark) #formContent #formFooter button:last-child:disabled {
  background: #475569 !important;
  border-color: #475569 !important;
  color: #e2e8f0 !important;
  opacity: 0.75;
}
:host-context(body.theme-dark) input[type=text],
:host-context(body.theme-dark) input[type=password] {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) input[type=text]:focus,
:host-context(body.theme-dark) input[type=password]:focus {
  background-color: #1f2937 !important;
  border-bottom-color: #5ea1d8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/registration/registration.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,UAAA;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACE,kCAAA;EACA,aAAA;AAGF;;AAAA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAGF;;AAAA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAEF;;AACA;EAEE,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,kBAAA;EACA,6BAAA;AAEF;;AACA;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AAEF;;AACA,SAAA;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,gCAAA;AACF;;AAEA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,yBAAA;EAKA,gCAAA;AAAF;;AAGA;;;EAGE,yBAAA;AAAF;;AAGA;;;EAOE,sBAAA;AAAF;;AAGA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AAAF;;AAGA;;EAEE,sBAAA;EACA,gCAAA;AAAF;;AAGA;;EAEE,cAAA;AAAF;;AAGA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AADF;AAiBA;EACE;IACE,UAAA;IAEA,mCAAA;EAFF;EAIA;IACE,UAAA;IAEA,eAAA;EAFF;AACF;AAKA,kCAAA;AAiBA;EACE;IACE,UAAA;EAHF;EAKA;IACE,UAAA;EAHF;AACF;AAMA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AANF;;AASA;EAGE,qBAAA;AANF;;AASA;EAGE,qBAAA;EACA,6BAAA;AANF;;AASA;EAGE,qBAAA;EACA,6BAAA;AANF;;AASA;EAGE,mBAAA;EACA,6BAAA;AANF;;AASA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA,WAAA;AAEA;EACE,aAAA;AAPF;;AAUA;EACE,UAAA;AAPF;;AASA;EACE,mBAAA;AANF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;;AASA;EACE,iCAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,4DAAA;EACA,2BAAA;AAPF;AAQE;EACE,2BAAA;EACA,0BAAA;EACA,qCAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,SAAA;AANJ;AAQI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AANN;AAQM;EACE,qCAAA;AANR;AASM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAPR;AAUM;EACE,WAAA;AARR;AAYE;EACE,UAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAVJ;AAWI;EACE,WAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;AATN;AAWI;EACE,4BAAA;AATN;AAYE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EAgBA,6BAAA;EAgBA,6BAAA;AAxCJ;AAUI;;EAEE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kFAAA;EACA,2BAAA;AARN;AAYI;;EAEE,kCAAA;EACA,iCAAA;EACA,yBAAA;EACA,sCAAA;AAVN;AAYM;;;EAEE,8CAAA;EACA,yBAAA;EACA,gCAAA;AATR;AAcI;;;EAGE,8BAAA;EACA,iCAAA;EACA,yBAAA;EACA,sCAAA;AAZN;AAcM;;;;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AATR;AAYM;;;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AARR;AAYE;EACE,UAAA;EACA,aAAA;AAVJ;AAYE;EACE,oDAAA;AAVJ;AAYE;EACE,yBAAA;EACA,0BAAA;AAVJ;;AAcA;EACE;IACE,eAAA;IACA,eAAA;EAXF;AACF;AAaA;EACE;IACE,eAAA;EAXF;EAYE;IACE,eAAA;IACA,WAAA;EAVJ;EAWI;IACE,WAAA;EATN;EAYE;IACE,qBAAA;EAVJ;EAYE;IACE,uBAAA;EAVJ;AACF;AAiBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAfF;;AAmBE;EACE,oCAAA;EACA,yBAAA;AAhBJ;AAmBE;;EAEE,8BAAA;EACA,iDAAA;EACA,oDAAA;EACA,yBAAA;EA8BA,uEAAA;EAuBA,sCAAA;AApEJ;AAiBI;;EACE,yBAAA;AAdN;AAiBI;;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAdN;AAgBM;;EAA+B,0CAAA;AAZrC;AAaM;;EAAsB,0CAAA;AAT5B;AAUM;;EAA0B,0CAAA;AANhC;AAOM;;EAAqB,0CAAA;AAH3B;AAMI;;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAHN;AAMI;;;;;;;;EAIE,yBAAA;AAAN;AAMM;;;;;;;;;;;;EAGE,yBAAA;AAKR;AAFM;;;;EACE,yBAAA;AAOR;AAJM;;;;EACE,gCAAA;AASR;AALI;;EACE,oCAAA;EACA,gCAAA;AAQN;AAHM;;;;EAEE,oCAAA;AAOR;AAJM;;;;;;EAGE,yBAAA;AASR;AANM;;;;;;EAGE,yBAAA;AAWR;AARM;;EACE,yBAAA;AAWR;AARM;;;;EAEE,yDAAA;AAYR;AARI;;EACE,yBAAA;AAWN;AARI;;EACE,sDAAA;AAWN;AARI;;EACE,yBAAA;AAWN;AARI;;EACE,kCAAA;EACA,2BAAA;AAWN;AATM;;;;EAEE,kCAAA;EACA,yBAAA;EACA,sCAAA;AAaR;AAXQ;;;;;;;EAEE,gDAAA;EACA,yBAAA;EACA,gCAAA;AAkBV;AAdM;;;;;;EAGE,8BAAA;EACA,yBAAA;EACA,sCAAA;AAmBR;AAjBQ;;;;;;;;;;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AA4BV;AAzBQ;;;;;;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;EACA,aAAA;AAgCV;AA1BE;;EAEE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA4BJ;AAzBE;;EAEE,oCAAA;EACA,uCAAA;AA2BJ","sourcesContent":["/* BASIC */\n\n.Login {\n  background-color: white;\n  position: relative;\n  z-index: 1;\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  max-width: 450px;\n  position: relative;\n  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: 0.5px solid lightgrey;\n}\n\n#formFooter {\n  background: transparent;\n  border-top: none;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 0px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n.Login {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  // padding: 20px 0px;\n}\n.formContent {\n  font-family: \"Raleway\" !important;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  max-width: 450px;\n  position: relative;\n  text-align: center;\n  min-width: 450px;\n  overflow: hidden; // CDK overlays render outside component tree, so this doesn't affect dropdowns\n\n  padding: 20px 0px 0px;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%) !important;\n  border: 1px solid lightgrey;\n  .top-head {\n    font-weight: 500 !important;\n    font-size: 22px !important;\n    color: rgba(0, 0, 0, 0.54) !important;\n    line-height: 26px !important;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 23px 0 33px;\n    margin: 0;\n    \n    .auth-modal-close {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: none;\n      border-radius: 50%;\n      margin-left: auto;\n      margin-right: 0;\n      padding: 0;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n      \n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n      \n      mat-icon {\n        color: #606060;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        transition: color 0.2s ease;\n      }\n      \n      &:hover mat-icon {\n        color: #333;\n      }\n    }\n  }\n  .form-group {\n    width: 85%;\n    max-width: 85%;\n    margin: 0 auto 20px;\n    overflow: visible; // Ensure dropdowns can show\n    input {\n      width: 100%;\n      background-color: #fff;\n      margin: 0;\n      padding: 8px 32px;\n      border: 1px solid lightgray;\n      font-size: 16px;\n    }\n    mat-form-field {\n      overflow: visible !important; // Ensure mat-select dropdown can show\n    }\n  }\n  #formFooter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 25px 25px 0px 25px;\n    background: transparent;\n    border-top: none;\n    max-width: 100%;\n    width: 100%;\n\n    button,\n    button.btn {\n      font-family: \"Raleway\", sans-serif;\n      font-size: 15px;\n      font-weight: 600;\n      cursor: pointer;\n      padding: 10px 18px;\n      border-radius: 10px;\n      min-width: 110px;\n      line-height: 1.3;\n      transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n      box-shadow: none !important;\n    }\n\n    /* Sign In — outline button */\n    .btn-auth-secondary,\n    button:first-child {\n      background: transparent !important;\n      background-image: none !important;\n      color: #5ea1d8 !important;\n      border: 1.5px solid #5ea1d8 !important;\n\n      &:hover,\n      &:focus {\n        background: rgba(94, 161, 216, 0.1) !important;\n        color: #4a8fc4 !important;\n        border-color: #4a8fc4 !important;\n      }\n    }\n\n    /* Sign Up — filled primary */\n    .btn-auth-primary,\n    button[type=\"submit\"],\n    button:last-child {\n      background: #5ea1d8 !important;\n      background-image: none !important;\n      color: #ffffff !important;\n      border: 1.5px solid #5ea1d8 !important;\n\n      &:hover,\n      &:focus {\n        background: #4a8fc4 !important;\n        border-color: #4a8fc4 !important;\n        color: #ffffff !important;\n      }\n\n      &:disabled {\n        background: #94a3b8 !important;\n        border-color: #94a3b8 !important;\n        color: #ffffff !important;\n        opacity: 0.7;\n        cursor: not-allowed;\n      }\n    }\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .formContent {\n    max-width: 100%;\n    padding: 0 20px;\n  }\n}\n@media (max-width: 460px) {\n  .formContent {\n    min-width: auto;\n    .form-group {\n      max-width: 100%;\n      width: 100%;\n      input {\n        width: 100%;\n      }\n    }\n    #formFooter {\n      padding: 25px 0px 0px;\n    }\n    .top-head {\n      padding: 20px 6px 0 5px;\n    }\n  }\n  .Login > div {\n    // width: calc(100% - 30px);\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  .formContent,\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n    color: #e5e7eb !important;\n\n    .top-head {\n      color: #e5e7eb !important;\n    }\n\n    input {\n      background: #111827 !important;\n      color: #e5e7eb !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n\n      &::-webkit-input-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &::-moz-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &:-ms-input-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &:-moz-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n    }\n\n    .form-group input {\n      background: #111827 !important;\n      color: #e5e7eb !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n    }\n\n    .example-margin,\n    .example-section,\n    .checkbox-section,\n    p {\n      color: #e5e7eb !important;\n    }\n\n    /* I agree checkbox — Material MDC label stays dark unless overridden */\n    ::ng-deep .mat-mdc-checkbox,\n    ::ng-deep .mat-checkbox {\n      .mdc-label,\n      label,\n      .mat-checkbox-label {\n        color: #e5e7eb !important;\n      }\n\n      a {\n        color: #93c5fd !important;\n      }\n\n      .mdc-checkbox__background {\n        border-color: #94a3b8 !important;\n      }\n    }\n\n    ::ng-deep .mat-mdc-checkbox.mat-mdc-checkbox-checked .mdc-checkbox__background {\n      background-color: #5ea1d8 !important;\n      border-color: #5ea1d8 !important;\n    }\n\n    /* User Type mat-select / form field */\n    ::ng-deep .mat-mdc-form-field {\n      .mdc-text-field--filled:not(.mdc-text-field--disabled),\n      .mat-mdc-text-field-wrapper {\n        background-color: #111827 !important;\n      }\n\n      .mdc-floating-label,\n      .mat-mdc-floating-label,\n      mat-label {\n        color: #94a3b8 !important;\n      }\n\n      .mat-mdc-select-value,\n      .mat-mdc-select-min-line,\n      .mat-mdc-select-placeholder {\n        color: #e5e7eb !important;\n      }\n\n      .mat-mdc-select-arrow {\n        color: #94a3b8 !important;\n      }\n\n      .mdc-line-ripple::before,\n      .mdc-line-ripple::after {\n        border-bottom-color: rgba(148, 163, 184, 0.35) !important;\n      }\n    }\n\n    .auth-modal-close mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    .auth-modal-close:hover {\n      background-color: rgba(255, 255, 255, 0.08) !important;\n    }\n\n    .auth-modal-close:hover mat-icon {\n      color: #e5e7eb !important;\n    }\n\n    #formFooter {\n      background: transparent !important;\n      border-top: none !important;\n\n      .btn-auth-secondary,\n      button:first-child {\n        background: transparent !important;\n        color: #7eb8e8 !important;\n        border: 1.5px solid #7eb8e8 !important;\n\n        &:hover,\n        &:focus {\n          background: rgba(126, 184, 232, 0.12) !important;\n          color: #93c5fd !important;\n          border-color: #93c5fd !important;\n        }\n      }\n\n      .btn-auth-primary,\n      button[type=\"submit\"],\n      button:last-child {\n        background: #5ea1d8 !important;\n        color: #ffffff !important;\n        border: 1.5px solid #5ea1d8 !important;\n\n        &:hover,\n        &:focus {\n          background: #4a8fc4 !important;\n          border-color: #4a8fc4 !important;\n          color: #ffffff !important;\n        }\n\n        &:disabled {\n          background: #475569 !important;\n          border-color: #475569 !important;\n          color: #e2e8f0 !important;\n          opacity: 0.75;\n        }\n      }\n    }\n  }\n\n  input[type=\"text\"],\n  input[type=\"password\"] {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  input[type=\"text\"]:focus,\n  input[type=\"password\"]:focus {\n    background-color: #1f2937 !important;\n    border-bottom-color: #5ea1d8 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
